export const collarTypes = {
  BLUE: 1,
  WHITE: 2,
};
